import { NodeEdgeMapper } from '@iotv/datamodel-core';
import ApiGateway from '../../aws/api-gateway/ApiGateway';
const debug = process.env.REACT_APP_DEBUG && false;
export const getEntityContext = async ({ entities, includeCustomerGroups, includeDeviceConfigs, }) => {
    const res = { err: null, data: null };
    const params = { entities, includeCustomerGroups, includeDeviceConfigs };
    debug && console.log('getEntityContext params', params);
    const path = `/entity/getContext`;
    const apiRes = (await ApiGateway.post(path, params, 'ConsumerApi'));
    debug && console.log('getEntityContext apiRes', apiRes);
    if (apiRes.data) {
        res.data = { nodeEdgeMapper: new NodeEdgeMapper(apiRes.data.nodeEdgeMapper) };
    }
    else {
        res.err = apiRes.err;
    }
    return res;
};
